import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { GetUserConfig, SetPendingNotifications } from './user-config.actions';
import { UserConfigService } from './user-config.service';
import { Observable, tap } from 'rxjs';
import { patch } from '@ngxs/store/operators';
import { UserConfig } from './models/user-config.model';
import { RecommendationsDialogInfo } from './models/user-config.response';

export type UserConfigStateModel = {
  recommendationsDialogInfo: RecommendationsDialogInfo | undefined;
  pendingNotifications: boolean;
};

export const initialState: UserConfigStateModel = {
  recommendationsDialogInfo: undefined,
  pendingNotifications: false,
};

@State<UserConfigStateModel>({
  name: 'userConfig',
  defaults: initialState,
})
@Injectable()
export class UserConfigState {
  private readonly userConfigService = inject(UserConfigService);

  @Selector()
  static getRecommendationsDialogInfo(state: UserConfigStateModel) {
    return state.recommendationsDialogInfo;
  }
  @Selector()
  static getPendingNotifications(state: UserConfigStateModel) {
    return state.pendingNotifications;
  }

  @Action(GetUserConfig)
  getUserConfig(context: StateContext<UserConfigStateModel>): Observable<UserConfig> {
    return this.userConfigService.getUserConfig().pipe(
      tap((userConfig) => {
        context.setState(patch<UserConfigStateModel>(userConfig));
      })
    );
  }

  @Action(SetPendingNotifications)
  setPendingNotifications(context: StateContext<UserConfigStateModel>, { pendingNotifications }: SetPendingNotifications) {
    context.setState(patch<UserConfigStateModel>({ pendingNotifications: pendingNotifications }));
  }
}
